import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function Pagination({
    currentPage = 1,
    total,
    pageSize = 5,
    changePage,
}) {
    const { t } = useTranslation();
    const pages = useMemo(() => {
        const key = () => `${Math.random()}${Date.now()}`;
        const numberObj = (number) => ({
            type: 'page',
            key: key(),
            number,
        });
        const dotsObj = () => ({
            type: 'dots',
            key: key(),
        });
        const ret = [];
        if (total > 0 && pageSize >= total) {
            for (let i = 0; i < total; i += 1) {
                ret.push(numberObj(i + 1));
            }
            return ret;
        }
        if (total < 1) {
            const size = pageSize - 1;
            let counter = (currentPage - size) + 1;
            if (counter < 2) counter = 2;
            if (currentPage > 1) ret.push(numberObj(1));
            if (counter > 2) ret.push(dotsObj());
            for (let i = 0; i < size; i += 1) {
                if (counter > 1 && counter <= currentPage) ret.push(numberObj(counter));
                counter += 1;
            }
            return ret;
        }
        const size = pageSize - 2;
        let counter = currentPage - Math.floor(size / 2);
        if (currentPage > 0) ret.push(numberObj(1));
        if (counter + size >= total) counter -= (counter + size) - total;
        if (counter < 2) counter = 2;
        if (counter > 2) ret.push(dotsObj());
        for (let i = 0; i < size; i += 1) {
            ret.push(numberObj(counter));
            counter += 1;
        }
        if (counter < total) ret.push(dotsObj());
        ret.push(numberObj(total));
        return ret;
    }, [currentPage, pageSize, total]);

    return (
        <div className='pagination'>
            <span className='page'>
                <button
                    disabled={currentPage === 1}
                    onClick={() => changePage(currentPage - 1)}
                >
                    {t('Prev')}
                </button>
            </span>
            {
                pages.map(page => (
                    <span className='page' key={page.key}>
                        {
                            page.type === 'dots' ?
                                <button
                                    className="dots"
                                >
                                    ...
                                </button> :
                                page.number !== currentPage ?
                                    <button
                                        onClick={() => changePage(page.number)}
                                    >
                                        { page.text || page.number }
                                    </button> :
                                    <button className='active'>
                                        { page.number }
                                    </button>
                        }
                    </span>
                ))
            }
            <span className='page'>
                <button
                    disabled={currentPage === total}
                    onClick={() => changePage(currentPage + 1)}
                >
                    {t('Next')}
                </button>
            </span>
        </div>
    );
}
